import { createFileRoute } from "@tanstack/react-router";
import { ContentPage } from "@/features/marketing/content/content-page";
import { body } from "@/features/marketing/content/pages/help-invite-your-partner";
import { SEO } from "@/features/marketing/seo";

export const Route = createFileRoute("/_marketing/help/invite-your-partner")({
  head: SEO["/help/invite-your-partner"],
  component: () => <ContentPage path="/help/invite-your-partner" body={body} />,
});
